import { render } from "./ConfirmBox.vue?vue&type=template&id=c3289952&scoped=true"
import script from "./ConfirmBox.vue?vue&type=script&lang=js"
export * from "./ConfirmBox.vue?vue&type=script&lang=js"

import "./ConfirmBox.vue?vue&type=style&index=0&id=c3289952&scoped=true&lang=css"

import exportComponent from "D:\\xampp\\htdocs\\attendance\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3289952"]])

export default __exports__